import PropTypes from 'prop-types'
import { memo, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import SVGLogo from '@/resources/svg/logo/icon.svg'
import classNames from '@/lib/util/classNames'
import ClipWedge from '../ClipWedge/ClipWedge'
import * as styles from './Logo.module.scss'

/**
 * The `Logo`
 * @param props
 * @returns {React.ReactElement} the element
 */
function Logo (props) {
  const { className } = props
  const [isHover, setIsHover] = useState(false)
  const classNameOutput = useMemo(
    () => classNames(styles.logo, className, isHover && styles.hover),
    [className, isHover]
  )

  return (
    <ClipWedge
      Tag={Link}
      to="/"
      className={classNameOutput}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <SVGLogo />
    </ClipWedge>
  )
}

Logo.propTypes = {
  className: PropTypes.string
}

export default memo(Logo)
